// src/components/ui/Toasts.js
import React from 'react';

const Toasts = ({ toasts }) => (
  <div className="fixed bottom-20 md:bottom-6 right-4 z-[70] space-y-2">
    {toasts.map((t) => (
      <div
        key={t.id}
        className={`px-5 py-3 rounded-xl shadow-lg ${t.leaving ? 'animate-toast-out' : 'animate-slide-up'} ${
          t.y === 'error' ? 'bg-red-500 text-white' : 'bg-emerald-500 text-white'
        }`}
      >
        {t.m}
      </div>
    ))}
  </div>
);

export default Toasts;
